import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { UserNotification } from 'projects/app-misc/src/app/modules/notification/data/user-notification';
import { OverlayPanel } from 'primeng/overlaypanel';
import { NotificationService } from 'projects/app-misc/src/app/modules/notification/data/notification.service';
import { NotificationsQuery } from 'projects/app-misc/src/app/modules/notification/data/notifications.query';
import { WsService } from 'projects/app-misc/src/app/modules/data/ws.service';
import { WsUpdateResponce } from 'projects/app-misc/src/app/modules/data/ws-update-responce';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { RxJSUnsubscribable } from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import { RxJSUnsubscribe } from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';

@Component({
  selector: 'app-mention-panel',
  templateUrl: './mention-panel.component.html',
  styleUrls: ['./mention-panel.component.scss']
})
@RxJSUnsubscribe
export class MentionPanelComponent implements OnInit, OnDestroy, RxJSUnsubscribable {
  @Input()
  notificationOP: OverlayPanel

  notifications: UserNotification[] = [];

  limit = 4;

  wsSub: Subscription;

  constructor(
    protected notificationService: NotificationService,
    protected notificationQuery: NotificationsQuery,
    protected wsService: WsService) {
  }

  ngOnInit(): void {
    this.updateNfs();
    this.wsSub = this.wsService
    .listenUntilDestroyed<WsUpdateResponce<UserNotification>>('/topic/update/model.notification.MentionNotification', this)
    .pipe(
      debounceTime(2000)
    )
    .subscribe(updateInfo => {
      this.updateNfs();
    })
  }

  updateNfs() {
    this.notificationService.getMentions(0, 10).subscribe(page => {
      this.notifications = page.content
      this.notificationService.unreadMentions.next()
    })
  }

  ngOnDestroy() {
    if(this.wsSub) {
      this.wsSub.unsubscribe()
      this.wsSub = null;
    }
  }

  openNFPage() {
    this.notificationOP.hide()
  }

  getUnsubFromAllSubs(): Subject<boolean> {
    return null
  }


}
